import { useMutation } from "@tanstack/react-query";
import api from "../services/api";

type Payload = {
  sha1: string;
};

const mutationFn = ({ sha1 }: Payload) => api.reclassifySample(sha1);

const useReclassifySample = () => {
  const { mutateAsync } = useMutation({
    mutationKey: ["reclassifySample"],
    mutationFn
  });

  return { reclassify: mutateAsync };
};

export default useReclassifySample;
